import React, { useMemo, useRef } from "react";
import { Printer } from "lucide-react";
import { previewHtml, ZP } from "../compile";
import { printDocument } from "../../../../helper-components/printing/print-service";
import { Modal, PrimaryBtn, SecondaryBtn } from "./ui";

// Shows the format exactly as it will print: the same HTML the backend
// serves, filled with the editor's data, in an isolated frame.
export default function PreviewModal({ template, sample, sourceLabel, onClose }) {
  const frame = useRef(null);
  const html = useMemo(() => previewHtml(template, sample), [template, sample]);
  const ps = ZP.paperSize(template);
  const out = useMemo(() => ZP.renderDocument(template, sample), [template, sample]);

  // same path as real prints: chosen printer, exact paper size, mismatch check
  const print = () => printDocument({ html, copies: 1, preview: false }, { docType: template.docType });

  return (
    <Modal
      title={`Preview · ${template.name || "Untitled"} · ${ps.continuous ? `${ps.width} mm roll` : `${ps.width} × ${ps.height} mm`}`}
      onClose={onClose}
      width="max-w-5xl"
      footer={
        <>
          <span className="mr-auto text-[11px] text-667085 self-center">Filled with {sourceLabel || "sample data"}. Each real print uses its own document's data.</span>
          <SecondaryBtn onClick={onClose}>Close</SecondaryBtn>
          <PrimaryBtn onClick={print}>
            <Printer size={14} /> Test print
          </PrimaryBtn>
        </>
      }
    >
      {(out.errors.length > 0 || out.warnings.length > 0) && (
        <div className="mx-4 mt-3 p-2 rounded border border-F51D00 text-[11px] text-F51D00 bg-white">
          {[...new Set(out.errors)].slice(0, 6).map((e) => (
            <div key={e}>⚠ {e}</div>
          ))}
          {out.warnings.slice(0, 6).map((w) => (
            <div key={w} className="text-344054">
              • {w}
            </div>
          ))}
        </div>
      )}
      <iframe ref={frame} title="Print preview" srcDoc={html} className="w-full border-0 bg-gray-200" style={{ height: "75vh" }} />
    </Modal>
  );
}
